export default __webpack_public_path__ + "f3e8fbc25af956a7ef73d818867012bb.svg";